import { storeSession } from 'Utilities/Session'
import { triplaServer } from 'src/apis/server'
import { serialize } from 'object-to-formdata'

export function SignIn(params, config) {
  return triplaServer
    .post('api/v1/auth/anonymous_sign_in', serialize(params), config)
    .then((res) => {
      storeSession(res.data.data.session)
      return res
    })
}

export function ConnectLineLiffUser(uidToken, lineLiffToken){
  return triplaServer
    .post('/liff/upsert', serialize({
      uid: uidToken,
      line_id_token: lineLiffToken
    })
  )
  .then((res) => res.data)
}

export function TriplaUID() {
  return triplaServer
    .get('user/tripla_uid', {
      headers: {
        'App-Version': 'tripla-booking-widget/1.0', // TODO: remove this after /user/tripla_uid allows App-Version: triplabot/1.0
        'client-session': sessionStorage.get('triplabot_client_session')
      }
    })
    .then((res) => {
      // const session = res.headers['authorization']
      // if (session) {
      //   storeSession(session)
      // }

      return res.data
    })
}

export function SignUpKnownUser(inputName, inputEmail, hotelId) {
  return triplaServer
    .post(
      'api/v1/auth/sign_up_known_user',
      serialize({
        name: inputName,
        email: inputEmail
      }),
      {
        params: { hotel_id: hotelId }
      }
    )
    .then((res) => res.data)
}

export function SignInKnownUser(credential) {
  // When signing in, pubnub fires twice, one before receiving the JSON file, and one after.
  // The second one is OK, but the first one does not look it is needed
  return triplaServer
    .post('api/v1/auth/sign_in_known_user', serialize(credential))
    .then((res) => res.data)
}

export function SignOutKnownUser() {
  return triplaServer.post('api/v1/auth/sign_out_known_user').then((res) => res.data)
}

export function SendForgottenPasswordRequest(email) {
  return triplaServer
    .post('api/v1/auth/password_reset', serialize({ email }))
    .then((res) => res.data)
}

export function UpdateEmail(email, chatId) {
  return triplaServer
    .put(
      'api/triplabot/v1/users/update_email',
      serialize({
        email,
        chat_id: chatId
      })
    )
    .then((res) => res.data)
}

export function AcceptTermsConditions(hotelId) {
  return triplaServer
    .put(
      'api/triplabot/v1/user/terms_and_conditions',
      serialize({
        hotel_id: hotelId,
        accept_terms_and_conditions: true
      })
    )
    .then((res) => res.data)
}

export function GetTermsConditionsStatus(hotelId) {
  return triplaServer
    .get('api/triplabot/v1/user/terms_and_conditions', {
      params: {
        hotel_id: hotelId
      }
    })
    .then((res) => res.data)
}

export function UpdateCookiePreferences(data) {
  return triplaServer.put('api/triplabot/v1/user/cookie_consent', data).then((res) => res.data)
}

export default {
  SignIn,
  SignUpKnownUser,
  SignInKnownUser,
  SignOutKnownUser,
  SendForgottenPasswordRequest,
  UpdateEmail,
  AcceptTermsConditions,
  GetTermsConditionsStatus,
  UpdateCookiePreferences,
  TriplaUID,
  ConnectLineLiffUser
}
